module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<style>\r\n    .selectApp{\r\n		width: 75%!important;\r\n	}\r\n    @media (min-width: 1400px) {\r\n	.selectApp{\r\n		width: 84%!important;\r\n	}\r\n}\r\n</style>\r\n<div class=\"block\">\r\n    <h2 id=\"test\">Details</h2>\r\n    <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n            <span>App</span>\r\n        </div>\r\n        <div class=\"col-sm-9\">\r\n            <input type=\"text\" class=\"connection selectApp\" name=\"_formName\" value=\"")
    ; __append(escapeFn( currentConnectionDetails.ConnectionXML.Connection['_formName'] ))
    ; __append("\" disabled/>\r\n            <input type=\"button\" name=\"selectForm\" class=\"btn btn-default form-select buttonWithInput\" value=\"Select\" style=\"height: 26px;padding: 0 18px\" />\r\n        </div>\r\n        <div class=\"col-sm-2\">\r\n           \r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}